import { lazy, Suspense } from 'react';

import { ModalWrapper } from '@braskai/ui-kit';

import { useScreenRecordPromoBannerStore } from '@/features/screenRecordPromo';

const ScreenRecordPromoBannerContent = lazy(() =>
  import('./ScreenRecordPromoBannerContent').then((module) => ({
    default: module.ScreenRecordPromoBannerContent,
  })),
);

export const ScreenRecordPromoBanner = () => (
  <ModalWrapper hook={useScreenRecordPromoBannerStore}>
    <Suspense fallback={null}>
      <ScreenRecordPromoBannerContent />
    </Suspense>
  </ModalWrapper>
);
